<template>
  <FormField :label="label" :error="error" :hint="hint" :id="id" v-slot="{ id: fieldId, invalid, describedBy }">
    <textarea
      :id="fieldId"
      class="input"
      :value="modelValue"
      :aria-invalid="invalid || undefined"
      :aria-describedby="describedBy"
      v-bind="$attrs"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    ></textarea>
  </FormField>
</template>

<script setup lang="ts">
import FormField from "./FormField.vue"

/**
 * Standard multi-line input with the label/error/hint triad built in. Wraps
 * the global .input class (textarea.input resizes vertically) — never
 * restyle a <textarea> inline. Native attributes (rows, maxlength,
 * placeholder, disabled, …) fall through to the <textarea>.
 */
defineOptions({ inheritAttrs: false })

withDefaults(
  defineProps<{
    modelValue?: string
    label?: string
    error?: string
    hint?: string
    id?: string
  }>(),
  { modelValue: "" },
)

defineEmits<{
  (e: "update:modelValue", value: string): void
}>()
</script>
